export const calculateNumberOfTrackedAssets = (
  yearlyVolume: number,
  percentageToTrack: number,
): number => {
  return Math.round((yearlyVolume * percentageToTrack) / 100)
}

export const calculateTotalBusinessLoss = (
  expenses: Record<string, number>,
): number => {
  return Object.values(expenses).reduce((sum, value) => sum + value, 0)
}

export const calculateTotalSavings = (
  expenses: Record<string, number>,
  improvements: Record<string, number>,
): number => {
  return Object.keys(expenses).reduce((sum, key) => {
    const expense = expenses[key] || 0
    const improvement = improvements[key] || 0
    return sum + expense * (improvement / 100)
  }, 0)
}

export const calculateAnnualInvestment = (
  numberOfTrackedAssets: number,
  investment: { labelPrice: number; cloudSubscription: number },
): number => {
  return (
    numberOfTrackedAssets * investment.labelPrice +
    numberOfTrackedAssets * investment.cloudSubscription
  )
}

export const calculateBenefits = (
  totalSavings: number,
  annualInvestment: number,
) => {
  if (annualInvestment === 0) {
    return {
      businessImprovement: totalSavings,
      businessImprovementNet: totalSavings,
      paybackTermMonths: 0,
      roiPercentage: 0,
    }
  }

  const businessImprovementNet = totalSavings - annualInvestment
  const paybackTermMonths =
    businessImprovementNet > 0
      ? businessImprovementNet / (totalSavings / 12)
      : Infinity
  const roiPercentage = (totalSavings / annualInvestment) * 100

  return {
    businessImprovement: totalSavings,
    businessImprovementNet,
    paybackTermMonths,
    roiPercentage,
  }
}
